import { Permission } from 'app/(secured)/(robot)/[robotId]/settings/access/types';

export const permissionToValueMap: Record<Permission, string> = {
  [Permission.VIEW]: 'View',
  [Permission.CONTROL]: 'Control',
  [Permission.MISSION_EXECUTION]: 'MissionExecution',
  [Permission.ARM_CONTROL]: 'ArmControl',
};

export const getPermissionQueryString = (permission: Permission): string => {
  return `robotAccessPermissions=${permissionToValueMap[permission]}`;
};
